@if (DataService.SelectedMatch != null) {
  <table class="scoreTable">
    <thead>
      <tr>
        <th>Name</th>
        <th>TT</th>
        <th>Bd</th>
        <th>Sq</th>
        <th>Ts</th>
        <th>Total</th>
      </tr>
    </thead>
    <tr id="1">
      <td style="width: auto">{{DataService.SelectedMatch.player1Name}}</td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.ttScore1" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score11 id="Score11" (click)="Score11.select()"/></td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.badScore1" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score12 id="Score12" (click)="Score12.select()"/></td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.squashScore1" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score13 id="Score13" (click)="Score13.select()"/></td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.tScore1" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score14 id="Score14" (click)="Score14.select()"/></td>
      <td>{{DataService.SelectedMatch.score1}}</td>
    </tr>
    <tr id="2">
      <td style="width: auto">{{DataService.SelectedMatch.player2Name}}</td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.ttScore2" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score21 id="Score21" (click)="Score21.select()"/></td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.badScore2" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score22 id="Score22" (click)="Score22.select()"/></td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.squashScore2" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score23 id="Score23" (click)="Score23.select()"/></td>
      <td><input type="text" [(ngModel)]="DataService.SelectedMatch.tScore2" (ngModelChange)="FunctionService.calculateScores(DataService.SelectedMatch)" (keydown)="EditScoreKeyPress($event)" #Score24 id="Score24" (click)="Score24.select()"/></td>
      <td>{{DataService.SelectedMatch.score2}}</td>
    </tr>
  </table>
}
@if (DataService.SelectedMatch != null && DataService.isEditingMatchScore == true && DataService.LoggedInUser.accessLevel > 1) {
  <mat-button style="float: right;" type="button" class="edit-toggle-btn" (click)="saveMatchScore()">
    Save Score
  </mat-button>
}
<!-- <button class="btn-action" id="saveScoreButton" (click)="saveMatchScore()"*ngIf="DataService.SelectedMatch != null && isEditingMatchScore == true">Save Score</button> -->


<!-- <div id="ScoreEditModal">
<div class="window-bar" id="score-edit-window-bar">
  <label>Edit Score</label>
  <button type="button" id="btnCloseNewTorn" (click)="close()">X</button>
</div>
<div id="customDialogEditScore" style="margin: 5px; max-width: 550px;">

  <div *ngIf="DataService.LoggedInUser.accessLevel" style="float: left;"><input type="checkbox" name="chkDoNotProcess" id="chkDoNotProcess" [(ngModel)]="DataService.SelectedMatch.DoNotProcess" style="width: 12px; " /><label for="chkDoNotProcess" style="margin-top: 6px; font-size: 12px; ">Do Not Process</label></div>
  <label style="float: none;" id="Date">Date:</label><input type="datetime-local" name="DateOfMatch" id="DateOfMatch" [(ngModel)]="DataService.SelectedMatch.formatedDateOfMatch" />
  <button type="button" id="btnnoTennis" (click)="NoTennis(DataService.SelectedMatch)" style="float: right;">NO Tennis</button><br /><br />
  <table>
    <thead>
      <tr>
        <th style="width: 18% !important;">Players</th>
        <th>TT</th>
        <th>Bad</th>
        <th>Squash</th>
        <th *ngIf="DataService.SelectedMatch.noTennis != true">Tennis</th>
        <th></th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ DataService.SelectedMatch.player1Name }}</td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.ttScore1" id="TT1" onclick="this.select()" (keydown)="scoreKeydown($event)" /></td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.badScore1" id="Bad1" onclick="this.select()" (keydown)="scoreKeydown($event)" /></td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.squashScore1" id="Squash1" onclick="this.select()" (keydown)="scoreKeydown($event)" /></td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.tScore1" id="T1" onclick="this.select()" (keydown)="scoreKeydown($event)" *ngIf="DataService.SelectedMatch.noTennis != true" /></td>
        <td><input type="button" value="WO" (click)="WalkOver(1)" /></td>
        <td>{{DataService.SelectedMatch.ttScore1 + DataService.SelectedMatch.badScore1 + DataService.SelectedMatch.squashScore1 + DataService.SelectedMatch.tScore1 }}</td>
      </tr>
      <tr>
        <td>{{ DataService.SelectedMatch.player2Name }}</td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.ttScore2" id="TT2" onclick="this.select()" (keydown)="scoreKeydown($event)" /></td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.badScore2" id="Bad2" onclick="this.select()" (keydown)="scoreKeydown($event)" /></td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.squashScore2" id="Squash2" onclick="this.select()" (keydown)="scoreKeydown($event)" /></td>
        <td><input type="number" [(ngModel)]="DataService.SelectedMatch.tScore2" id="T2" onclick="this.select()" (keydown)="scoreKeydown($event)" *ngIf="DataService.SelectedMatch.noTennis != true" /></td>
        <td><input type="button" value="WO" (click)="WalkOver(2)" /></td>
        <td>{{DataService.SelectedMatch.ttScore2 + DataService.SelectedMatch.badScore2 + DataService.SelectedMatch.squashScore2 + DataService.SelectedMatch.tScore2 }}</td>
      </tr>
    </tbody>
  </table>
  <button type="button" id="submitScore" name="submitScore" (click)="Submit()">Submit Score</button><br />

  <label id="NeedsToWin">{{DataService.NeedToWinString}}</label>
</div>
</div> -->
